import axios from "axios";
import Swal from 'sweetalert2';

const state = {
    taskList: [],
    taskArr: [],
    taskArray: [],
    taskID: "",
    taskTitle: "",
    selectedTask: null,
    selectedLead: null,
    selectedOpportunity: null,
    selectedRep: null,
    isEditing: "",

  };
  
  const mutations = {
    initializeStore(state){
      state.taskList = [];
      state.taskArr = [];
      state.taskArray = [];
      state.taskID = '';
      state.taskTitle = '';
      state.selectedTask = null;
      state.selectedLead = null;
      state.selectedOpportunity = null;
      state.selectedRep = null;
      state.isEditing = false;
    },
    SET_SELECTED_TASK(state, task) {
      state.selectedTask = task;
      state.isEditing = true;
    },
    TASKS_ARRAY(state, tasks){
      state.taskArray = tasks;
    },
    LIST_LEAD_TASKS (state, tasks) {
      state.taskList = tasks;
    },
    SET_SELECTED_LEAD(state, lead) {
      state.selectedLead = lead;
    },
    SET_SELECTED_OPPORTUNITY(state, opportunity) {
      state.selectedOpportunity = opportunity;
    },
    SET_SELECTED_REP(state, rep) {
      state.selectedRep = rep;
    },
    SET_STATE(state, payload) {
      for (const key in payload) {
          if (payload.hasOwnProperty(key) && key in state) {
              state[key] = payload[key];
          }
      }
    },
    SET_SEARCH_FILTERS(state, search_filter){
      for(const [key, value] of Object.entries(search_filter)){
         
      }
    },
    RESET_SEARCH_FILTERS(state){
     
    }

  };
  
  const actions = {
    updateState({ commit }, newState) {
      commit('SET_STATE', newState);
    },
    
    async createLeadTask({ commit,state }, formData) {
      return axios.post('api/v1/create-lead-task/', formData)
      .then((response)=>{
        return response;
      })
      .catch((error)=>{
        console.log(error.message);
        throw error;
      })
    },
  
    fetchLeadTasks({ commit,state }, formData) {
      state.taskArr = [];
      axios.post(`api/v1/get-lead-tasks/`,formData)
      .then((response)=>{
        for(let i=0; i< response.data.length; i++){
          state.taskArr.push((response.data[i].title + " - " + response.data[i].task_type));
        }
        commit('LIST_LEAD_TASKS', response.data);
      })
      .catch((error)=>{
        console.log(error.message);
      })
      
    },
    fetchLeadTask({ commit,state }, formData) {
      axios.post(`api/v1/get-lead-tasks/`,formData)
      .then((response)=>{
        state.selectedTask = response.data;
        const selectedLead = (response.data.related_lead != null) ? (response.data.related_lead.full_name + " - " + response.data.related_lead.email)  : "";
        const selectedRep = (response.data.assigned_to != null) ? (response.data.assigned_to.name  + " - Email: " + response.data.assigned_to.email)  : "";
        const selectedOpportunity = (response.data.related_opportunity != null) ? (response.data.related_opportunity.name + " - Value: " + response.data.related_opportunity.value)  : "";
        
        commit('SET_SELECTED_TASK',response.data);
        commit('SET_SELECTED_LEAD',selectedLead);
        commit('SET_SELECTED_OPPORTUNITY',selectedOpportunity);
        commit('SET_SELECTED_REP',selectedRep);
      })
      .catch((error)=>{
        console.log(error.message);
      })
      
    },
    handleSelectedTask({ commit, state }, option){
      state.taskArray = [];
      const selectedTask = state.taskList.find(task => (task.title + " - " + task.task_type) === option);
      if (selectedTask) {
          state.taskID = selectedTask.crm_task_id;
          state.taskTitle = selectedTask.title;
          state.taskArray = [...state.taskArray, selectedTask];
      }
      commit('TASKS_ARRAY', state.taskArray);
        
    },
  
    async updateLeadTask({ commit,state }, formData) {
      return axios.put(`api/v1/update-lead-task/`,formData)
      .then((response)=>{
        return response;
      })
      .catch((error)=>{
        console.log(error.message);
        throw error;
      })  
    },
  
    deleteLeadTask({ commit,state }, formData) {
      Swal.fire({
        title: "Are you sure?",
        text: `Do you wish to delete Task?`,
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: 'Yes Delete Task!',
        cancelButtonText: 'Cancel!',
        customClass: {
            confirmButton: 'swal2-confirm-custom',
            cancelButton: 'swal2-cancel-custom',
        },
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          axios.post(`api/v1/delete-lead-task/`,formData)
          .then((response)=>{
            if(response.status == 200){
                Swal.fire("Poof! Task removed succesfully!", {
                  icon: "success",
                }); 
            }else{
              Swal.fire({
                title: "Error Deleting Task",
                icon: "warning",
              });
            }                   
          })
          .catch((error)=>{
            console.log(error.message);
            Swal.fire({
              title: error.message,
              icon: "warning",
            });
          })
        }else{
          Swal.fire(`Task has not been deleted!`);
        }
      })
    },
  };
  
  const getters = {
    // users: (state) => state.users,
    // currentUser: (state) => state.currentUser,
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
  };
  
  